import articlesData from "@/data/articles.json";

export const SITE = {
  name: "Ruta Inteligente",
  domain: "rutainteligente.com",
  url: "https://rutainteligente.com",
  tagline: "Viaja más por menos",
  description:
    "Guías, trucos y destinos para viajar low cost. Aprende a gastar menos en vuelos, alojamiento y transporte sin renunciar a vivir grandes viajes.",
};

export const CATEGORIES = [
  { slug: "destinos-baratos", name: "Destinos Baratos", short: "Destinos", desc: "Los lugares donde tu dinero rinde el doble.", color: "#C84B31" },
  { slug: "vuelos-baratos", name: "Vuelos Baratos", short: "Vuelos", desc: "Trucos y herramientas para volar pagando menos.", color: "#2D4221" },
  { slug: "alojamiento", name: "Alojamiento", short: "Alojamiento", desc: "Dormir bien gastando poco en cualquier ciudad.", color: "#A63D27" },
  { slug: "transporte", name: "Transporte", short: "Transporte", desc: "Moverte barato por tierra, mar y aire.", color: "#3a5a2a" },
  { slug: "guias-ciudades", name: "Guías de Ciudades", short: "Guías", desc: "Cómo visitar grandes ciudades low cost.", color: "#C84B31" },
  { slug: "consejos", name: "Consejos", short: "Consejos", desc: "Estrategias para ahorrar en cada viaje.", color: "#2D4221" },
];

export const articles = [...articlesData].sort((a, b) => (a.date < b.date ? 1 : -1));

export const getArticle = (slug) => articles.find((a) => a.slug === slug);
export const byCategory = (catSlug) => articles.filter((a) => a.categorySlug === catSlug);
export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const related = (article, n = 3) =>
  articles.filter((a) => a.categorySlug === article.categorySlug && a.slug !== article.slug).slice(0, n);

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};

export const search = (q) => {
  const t = q.trim().toLowerCase();
  if (!t) return [];
  return articles.filter(
    (a) => a.title.toLowerCase().includes(t) || a.keyword.toLowerCase().includes(t) || a.excerpt.toLowerCase().includes(t)
  );
};
